import NavbarComponent from "@/components/Navbar"
import GreekLine from "@/components/GreekLine"
import SEO from "@/components/SEO"
import { Link } from "react-router-dom"
import { Button } from "@/components/Button"

const Announcements = () => {
  return (
    <>
      <SEO />
      <NavbarComponent bgColor="bg-white" />
      <section className="bg-[url('/src/assets/imgs/di-sana/slide-07.jpg')] h-[50vh] w-full bg-cover relative">
        <GreekLine custCls="bottom-0 absolute w-full" />
      </section>
      <div className="px-5 sm:px-10 py-6 sm:py-8">
        <h1 className="font-sloopScriptPro text-6xl sm:text-8xl text-[#95702e] font-bold mb-3 text-center">Temporary Closure Notice</h1>
        <div className="flex flex-col items-center justify-center mb-6">
          <p className="text-charcoal-black text-base sm:text-2xl font-light font-agcasmlt sm:w-1/2 lg:w-[35%] inline-block text-center">
            We will be closed on Monday, July 27, 2026 for scheduled maintenance.
          </p>
          <p className="text-charcoal-black text-base sm:text-2xl font-light font-agcasmlt sm:w-1/2 lg:w-[35%] inline-block text-center">
            We will reopen on Tuesday, July 28, 2026 at 10:00 AM.
          </p>
          <p className="text-charcoal-black text-base sm:text-2xl font-light font-agcasmlt sm:w-1/2 lg:w-[35%] inline-block mb-6 text-center">
            We appreciate your understanding.
          </p>
          <p className="text-charcoal-black text-base sm:text-2xl font-light font-agcasmlt sm:w-1/2 lg:w-[35%] inline-block mb-6 text-center">
            Di Sini Di Sana by Rachman & Son
          </p>
        </div>
        <div className="flex gap-3 sm:gap-5 items-center justify-center w-full md:w-3/4 lg:w-1/3 mx-auto">
          <div className="w-full p-1 bg-[#6e6060]">
            <Link to="/" className="pt-2 font-agcasmlt font-light text-lg sm:text-xl lg:text-2xl text-white block text-center">
              Back to Home
            </Link>
          </div>
          <div className="p-1 border border-[#dcd6d2] w-full">
            <Link to="/di-sini/reservation" className="pt-2 font-agcasmlt font-light text-lg sm:text-xl lg:text-2xl text-[#6e6060] block text-center">
              Make a Reservation
            </Link>
          </div>
          {/* <div className="mb-2.5">
            <Button type="submit" title="Add to cart" onlyBorder custCls="border-[#dcd6d2] text-lg sm:text-xl lg:text-2xl font-light pt-2 pb-1" />
          </div>
          <div>
            <Button processBtn type="submit" title="Buy it now" custCls="text-lg sm:text-xl lg:text-2xl font-extralight pt-2 pb-1" />
          </div> */}
        </div>
      </div>
    </>
  )
}

export default Announcements
